import {
	CLEAR,
	ERROR,
	SUCCESS,
	LOADING,
	GET_STATUS, GET_POSITIONS
} from "./trackerActionsCreator";

const defaultState = {
	status:[],
	devices:{}
};

export default function trackerReducer(state = defaultState, action) {
	switch (action.type) {
		case LOADING: {
			return {
				...state,
				loading: action.data
			};
		}
		case ERROR: {
			return {
				...state,
				loading: false,
				error: action.data
			};
		}
		case SUCCESS: {
			return {
				...state,
				loading: false,
				success: true
			};
		}
		case CLEAR: {
			return {
				...state,
				loading: false,
				success: false,
				error: null
			};
		}
		case GET_STATUS: {
			return {
				...state,
				status:action.data
			};
		}
		case GET_POSITIONS: {
			let newPos = Object.assign({}, state.devices);
			newPos[action.data.device] = action.data.positions;
			return {
				...state,
				devices: newPos
			};
		}
		default: return state;
	}
}